module.exports = __webpack_public_path__ + "img/Laptop Icon - white.c91f56f9.svg";